import { useTranslation } from "react-i18next";

const features = [
  {
    icon: "ri-refresh-line",
    titleKey: "features.f1_title",
    descKey: "features.f1_desc",
  },
  {
    icon: "ri-link",
    titleKey: "features.f2_title",
    descKey: "features.f2_desc",
  },
  {
    icon: "ri-shield-check-line",
    titleKey: "features.f3_title",
    descKey: "features.f3_desc",
  },
];

export default function FeatureGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="mb-12">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-primary-600 mb-3">
            {t("features.tag")}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-[1.15]">
            {t("features.title_line1")}
            <br />
            {t("features.title_line2")}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-2xl p-8 md:p-10 hover:bg-background-100/80 transition-all duration-300"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-6 group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-foreground-950 mb-3 font-heading">
                {t(feat.titleKey)}
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                {t(feat.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}